import { UPDATE_LOT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_LOT.LOAD:
      return {
        ...state,
        loading: true
      };
    case UPDATE_LOT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case UPDATE_LOT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
